// extracted by mini-css-extract-plugin
export default {"container":"styles_container__xK58k","corelogicTrusted":"styles_corelogicTrusted__ftxNb"};